module.exports = __webpack_public_path__ + "static/media/serraGaucha.bc3f9559.png";